import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export const RELORecip = () => {
  return (
    <div class="row">
      <div class="col-md-6">
        <img className="img-fluid w-25 rounded-circle reloLogoBoarder " src="RELOgraphic2026.png" alt="VFW Tom" />
        <h2>Cody Beitz</h2>

  <div>💙R.E.L.O. RALLY 2026💙</div>
Please join us SATURDAY September 12th for our annual Relo Rally! This year's cancer warrior is local Cody Beitz, who is fighting stage 4 Squamous Cell Carcinoma. All proceeds and donations will go directly to his fight. 
<div>💙SILENT AUCTION 5PM </div>
💙LIVE AUCTION 8PM
<div>💙Karaoke to follow live auction! </div>
 <div>We will have many great items to be auctioned, from many amazing local donations and businesses! 
Please mark your calendars and share with your friends! Let's join together as a community to support Cody while remembering our dear friend Rick Eckel! 
If you are interested in donations or being a part of this year's event, please reach out:</div>
<div>Meadow Frank
(509)919-3788 </div>
              <a href="mailto:pjspub1717@gmail.com">
                pjspub1717@gmail.com
              </a>
<div>💙Be The Change💙</div>
      </div>
      
    </div>
  );
};
